import { render, staticRenderFns } from "./tipView.vue?vue&type=template&id=aaf3fd3e&scoped=true&"
import script from "./tipView.vue?vue&type=script&lang=js&"
export * from "./tipView.vue?vue&type=script&lang=js&"
import style0 from "./tipView.vue?vue&type=style&index=0&id=aaf3fd3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf3fd3e",
  null
  
)

component.options.__file = "tipView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDataTable,
  VFlex,
  VProgressCircular,
})
